<div *ngIf="selectedDataSets.length > 0" class="col-12">
  <h5 class="group-label">Data Sets</h5>
</div>
<div class="col-12">
  <!-- multiselect of datasets for regular users -->
  <kendo-multiselect *ngIf="!isDemoUser"
    id="dataSetsSelect"
    [data]="availableDataSets"
    [(ngModel)]="selectedDataSets"
    [textField]="'text'"
    [valueField]="'value'"
    (valueChange)="onValueChange()"
    [autoClose]="false"
    [placeholder]="'Select Data Sets to Include...'"
    [ngClass]="{'error-field': hasErrors}"
  >
    <ng-template kendoMultiSelectHeaderTemplate>
      <div class="select-all-checkbox-div" (click)="onSelectAllClick()">
          <input
            type="checkbox"
            id="chk"
            kendoCheckBox
            [checked]="isChecked"
            [indeterminate]="isIndet"
          
          />
          <kendo-label  for="chk" class="select-all-checkbox">{{ toggleAllText }}</kendo-label>
      </div>
    </ng-template>

    <ng-template kendoMultiSelectItemTemplate let-dataItem>
      <span>
        <kendo-label for="chk-{{ dataItem.value }}">
          <input
            type="checkbox"
            id="chk-{{ dataItem.value }}"
            kendoCheckBox
            [checked]="isItemSelected(dataItem)"
          />
        </kendo-label>
      </span>
      <span>{{ dataItem.text }}</span>
    </ng-template>
  </kendo-multiselect>

  <!-- multiselect of datasets for demo users only -->
  <kendo-multiselect *ngIf="isDemoUser"
    id="dataSetsSelect"
    [data]="availableDataSets"
    [(ngModel)]="selectedDataSets"
    [textField]="'text'"
    [valueField]="'value'"
    (valueChange)="onValueChange()"
    [autoClose]="false"
    [placeholder]="'Select Data Sets to Include...'"
    [ngClass]="{'error-field': hasErrors}"
    [itemDisabled]="itemDisabled"
  >

    <ng-template kendoMultiSelectItemTemplate let-dataItem>
      <span>
        <kendo-label for="chk-{{ dataItem.value }}">
          <input
            type="checkbox"
            id="chk-{{ dataItem.value }}"
            kendoCheckBox
            [checked]="isItemSelected(dataItem)"
          />
        </kendo-label>
      </span>
      <span>{{ dataItem.text }}</span>
    </ng-template>
  </kendo-multiselect>
</div>